module.exports = __webpack_public_path__ + "img/Binder.a7b11d33.jpg";